"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationVersionStruct = void 0;
const superstruct_1 = require("superstruct");
const Timestamp_1 = require("../utils/Timestamp");
exports.ApplicationVersionStruct = (0, superstruct_1.type)({
    version: (0, superstruct_1.string)(),
    releasedAt: Timestamp_1.TimestampStruct,
});
//# sourceMappingURL=appVersion.js.map